const routes = [
  {
    path: 'aggridcolfixed',
    name: 'aggridcolfixed',
    component: () => import(/* webpackChunkName: "aggridcolfixed" */ '@/modules/aggridcolfixed/index.vue')
  },
];

export default routes;